import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import AuthModal from '../components/auth/AuthModal';
import BasketModal from '../components/BasketModal';
import HouseCall from '../components/HouseCall';
import ExpiredModal from '../components/ExpiredModal';
import useWindowSize from '../hooks/useWindowSize';
import GoTopButton from '../components/GoTopButton';
import GiftCartForm from '../components/GiftCartForm';
import SchemaBreadcrumbs from '../components/SchemaBreadcrumbs';

function Wrapper({ children, breadcrumbs = [] }) {
  const {
    headerData,
  } = useSelector((state) => state.headerData);
  const [noFooter, setNoFooter] = useState(false);
  const location = useLocation();
  const { width } = useWindowSize();
  useEffect(() => {
    const isAccountUrl = location.pathname.endsWith('/account');
    if (isAccountUrl && width < 768) {
      setNoFooter(true);
    } else {
      setNoFooter(false);
    }
  }, [location]);
  return (
    <div style={!noFooter ? {
      display: 'flex',
      height: '99vh',
      justifyContent: 'space-between',
      flexDirection: 'column',
    } : { height: '96%' }}
    >
      <ToastContainer
        className="custom-toast"
        bodyClassName="custom-toast-body"
        progressClassName="custom-toast-progress"
        toastClassName="custom-toast-toast"
        position="top-right"
        autoClose={800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      <SchemaBreadcrumbs items={breadcrumbs} />
      <GiftCartForm />
      <ExpiredModal />
      <HouseCall />
      <AuthModal />
      <BasketModal />
      <Header data={headerData} />
      <main style={{
        height: noFooter ? '100%' : 'auto',
        marginTop: width < 768 ? '150px' : '',
      }}
      >
        {children}
      </main>
      {width > 768 && <GoTopButton />}
      {!noFooter && <Footer />}
    </div>
  );
}

export default Wrapper;
